var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ghost-button-link"},[(_vm.icon)?_c('VIconMTS',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }